var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ui-auth"},[_c('ui-title',{staticClass:"ui-auth__title",staticStyle:{"padding-top":"100px","font-size":"50px","line-height":"58px"}},[_vm._v(" 404 ")]),_c('div',{staticStyle:{"text-align":"center","font-size":"20px"}},[_vm._v(" "+_vm._s(_vm.$t('notFound'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }